import END_POINT from 'src/config/endpoints.constants';
import { ApiResponse, ApiResult, getErrorMessage } from '../lib/API';
import { CallRequest, UUID } from '../types';
import axios from 'axios';
export interface GetRequestByIdResult extends ApiResult {
    data?: {
        callRequest: CallRequest;
    };
}

export interface GetRequestByIdResponse extends ApiResponse {
    data: CallRequest;
}

export interface GetRequestByIdOptions {
    id: UUID;
    /** Includes switchDeviceList on the response; off by default. */
    withSwitchDeviceDetail?: boolean;
}

export default async function getRequestById(options: GetRequestByIdOptions) {
    const result: GetRequestByIdResult = {};
    try {
        const { data: responseData } = await axios.post<GetRequestByIdResponse>(
            END_POINT.GET_REQUEST_BY_ID,
            options,
        );
        if (responseData) {
            if (responseData.code === 0) {
                result.data = {
                    callRequest: responseData.data,
                };
            } else {
                result.error = responseData.message;
            }
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
